module.exports = __webpack_public_path__ + "img/event-1.e35e830a.png";